import React, { memo } from 'react';
import _ from 'lodash';
import { Row, Col } from '@duxton-web/ui';
import { Handle, Position } from 'reactflow';
import splitIcon from 'img/split.svg';
import 'components/journey-builder/css/split.scss';
import infoIcon from 'img/info.svg';
import { SPLIT_FUNC_TEXT, NODETYPE_REQUIRED_FIELDS, NODE_TYPES } from 'components/journey-builder/utils/constants';
import { getErrors } from 'components/journey-builder/utils/core';
import { MoreInfoFilled } from '@duxton-web/icons';

export default memo(({ data, isConnectable }) => {
  const hasError = getErrors(data, NODETYPE_REQUIRED_FIELDS[NODE_TYPES.split]);
  return (
    <div>
      {hasError && <MoreInfoFilled className="hasError" />}
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
      />
      <Row>
        <Col>
          <img src={splitIcon} height={'28px'} width={'28px'} alt={''} />
        </Col>
        <Col>
          <div className="title">
            <b>Decision Split #{data.nameIndex}</b>
          </div>
        </Col>
      </Row>
      <Row style={{ marginTop: 12 }}>
        <Col>
          <div className="categoryHeader">
          1st Condition
          </div>
          <div className="categoryContent">
            {SPLIT_FUNC_TEXT[data.func]} is {_.upperCase(data.splits[0])}
          </div>
        </Col>
      </Row>
      {data.showMetrics && data.processed_count > 0 && <div>
        <div className="divider" />
        <Row>
          <Col>
            <div className="progressTextHeader">
              Processed <img src={infoIcon} height={'12px'} width={'12px'} alt={''} />
            </div>
            <div className="progressTextContent">
              {((data.success_count / (data.totalCount || 0)) * 100).toFixed(1)} %
            </div>
          </Col>
        </Row>
      </div>}
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
      />
    </div>
  );
});
